import * as UserDAO from "@/dao/user-dao";
import router from "@/factories/router.factory";

export default {
  async getUserDetails({ commit }) {
    const user = await UserDAO.getUser();
    const features = user.features || [];
    if (!features.includes("comtool.login")) {
      router.replace("/error-no-access");
    } else {
      commit("setUser", user);
    }
    return user;
  },
};
